import { CommonModule } from '@angular/common';
import { Component, HostListener, Renderer2 } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RouteService } from '../../services/route.service';
import { environment } from '../../../environments/environment.production';
import { StoreService } from '../../services/store.service';

interface NotificationItem {
  id: number;
  message: string;
  time: string;
  type: 'info' | 'success' | 'warning';
  icon: string;
  unread: boolean;
}

interface StatCard {
  icon: string;
  value: string;
  label: string;
  color: 'blue' | 'green' | 'purple' | 'orange';
}

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, CommonModule, NgbDropdownModule, RouterModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  environment: any = environment;

  constructor(private renderer: Renderer2, private routeService: RouteService, private storeService: StoreService) {
    this.checkScreenSize();

    window.addEventListener('resize', () => this.checkScreenSize());

    const userDataString = localStorage.getItem('user');
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        environment.currentUser = userData;
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    } else {
      console.log('No user data found in localStorage');
    }

  }

  classes = [
    'main-layout',
  ]

  ngOnInit(): void {
    // Add class to the body tag
    this.classes.forEach((className) => {
      this.renderer.addClass(document.body, className);
    });
  }

  ngOnDestroy(): void {
    // Clean up by removing the class
    this.classes.forEach((className) => {
      this.renderer.removeClass(document.body, className);
    });
  }



  isSidebarCollapsed = false;
  isMobile = false;
  searchTerm = '';

  notifications: NotificationItem[] = [
    {
      id: 1,
      message: 'New user registration: John Doe has signed up',
      time: '2 minutes ago',
      type: 'info',
      icon: 'fas fa-info-circle',
      unread: true
    },
    {
      id: 2,
      message: 'Order #12345 has been successfully processed',
      time: '15 minutes ago',
      type: 'success',
      icon: 'fas fa-check-circle',
      unread: true
    },
    {
      id: 3,
      message: 'Server usage is above 80%. Consider upgrading your plan',
      time: '1 hour ago',
      type: 'warning',
      icon: 'fas fa-exclamation-triangle',
      unread: true
    },
    {
      id: 4,
      message: 'You have 5 new messages in your inbox',
      time: '3 hours ago',
      type: 'info',
      icon: 'fas fa-envelope',
      unread: false
    },
    {
      id: 5,
      message: 'Monthly report has been generated and is ready for download',
      time: '1 day ago',
      type: 'success',
      icon: 'fas fa-download',
      unread: false
    }
  ];

  statCards: StatCard[] = [
    {
      icon: 'fas fa-users',
      value: '2,543',
      label: 'Total Users',
      color: 'blue'
    },
    {
      icon: 'fas fa-shopping-cart',
      value: '1,234',
      label: 'Total Orders',
      color: 'green'
    },
    {
      icon: 'fas fa-dollar-sign',
      value: '$24,567',
      label: 'Total Revenue',
      color: 'purple'
    },
    {
      icon: 'fas fa-chart-line',
      value: '89.2%',
      label: 'Growth Rate',
      color: 'orange'
    }
  ];



  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 992;
    if (!this.isMobile) {
      this.isSidebarCollapsed = false;
    }
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }



  markNotificationAsRead(notification: NotificationItem): void {
    notification.unread = false;
  }

  markAllAsRead(): void {
    this.notifications.forEach(notification => {
      notification.unread = false;
    });
  }

  get unreadCount(): number {
    return this.notifications.filter(n => n.unread).length;
  }

  onSearch(): void {
    if (this.searchTerm.trim()) {
      alert(`Search functionality can be implemented here. Search term: ${this.searchTerm}`);
    }
  }

  onLogout(): void {
    this.storeService.clearAuthToken();
    this.storeService.clearUserData();
    this.routeService.login();
  }
}
